<template>
  <div class="card-container channel">
    <el-card>
      <common-el-form
        :model="formModel"
        :rules="formRules"
        :submitData="submitData"
        @success="onSuccess"
        submit-btn-text="提交"
        failTitle="提交失败"
        loadingText="提交中..."
        :submitService="submitService"
        :showButton="false"
      >
        <div>董事</div>
        <div style="display: flex">
          <div style="width: 360px">
            <el-form-item
              label-width="100px"
              label="直推"
              prop="managerDirectNum"
            >
              <el-input-number
                style="width: 132px"
                v-model="formModel.managerDirectNum"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
              <div
                style="
                  float: right;
                  font-size: 14px;
                  color: #606266;
                  margin-left: -15px;
                "
              >
                高级合伙人（个）
              </div>
            </el-form-item>
          </div>
          <div style="width: 350px; margin-left: 100px">
            <el-form-item label="分配月销售额（%）" prop="managerPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.managerPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <div>总裁</div>
        <div style="display: flex">
          <div style="width: 360px">
            <el-form-item
              label-width="100px"
              label="直推"
              prop="presidentDirectNum"
            >
              <el-input-number
                style="width: 132px"
                v-model="formModel.presidentDirectNum"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
              <div
                style="
                  float: right;
                  font-size: 14px;
                  color: #606266;
                  margin-left: -15px;
                "
              >
                高级合伙人（个）
              </div>
            </el-form-item>
          </div>
          <div style="width: 350px; margin-left: 100px">
            <el-form-item label="分配月销售额（%）" prop="presidentPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.presidentPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="开关" prop="status">
          <el-switch
            v-model="formModel.status"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import SelectLevel from "components/business/SelectLevel";
import ElFormItem from "element-ui/packages/form/src/form-item";
import OrganService from "service/OrganService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "identitymanage",
  data() {
    return {
      formRules: {
        managerDirectNum: [
          {
            required: true,
            message: "请输入",
          },
        ],
        managerPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        presidentDirectNum: [
          {
            required: true,
            message: "请输入",
          },
        ],
        presidentPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      formModel: {
        managerDirectNum: undefined,
        managerPercent: undefined,

        presidentDirectNum: undefined,
        presidentPercent: undefined,
        status: 0,
        id: "",
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElFormItem,
    CommonElForm,
    SelectLevel,
  },
  computed: {
    submitData() {
      this.params = {
        managerDirectNum: this.formModel.managerDirectNum,
        managerPercent: this.formModel.managerPercent,

        presidentDirectNum: this.formModel.presidentDirectNum,
        presidentPercent: this.formModel.presidentPercent,
        id: this.formModel.id,
        status: this.formModel.status,
      };
      return this.params;
    },
    submitService() {
      return OrganService.identitymanageUpdate;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.doLoad(
        OrganService.identitymanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.formModel = result;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.getDetail();
        this.showSuccess(res.contents.optMsg);
      });
    },
    ...mapActions({}),
  },
};
</script>

<style scoped>
span {
  font-size: 17px;
  margin-bottom: 10px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/IdentityManage.vue